import { render } from "./OphthalmologyPanel.vue?vue&type=template&id=a7e8e3e6"
import script from "./OphthalmologyPanel.vue?vue&type=script&lang=js"
export * from "./OphthalmologyPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__